module.exports = __webpack_public_path__ + "static/logo-dark-5ef3ac98c0bdad237a087a79cb56442b.svg";